export default function Datenschutz() {
  return (
    <main className="bg-[#020617] px-6 py-28">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
          <h1 className="text-3xl md:text-4xl font-semibold mb-8">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-semibold mb-4 mt-8">1. Verantwortlicher</h2>
            <p className="mb-4">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              <br />
              <strong>Abschlepp- und Bergungsdienst Schiek</strong>
              <br />
              Inhaber: Ahmad Ayyach
              <br />
              Reinickendorfer Straße 87
              <br />
              13347 Berlin
              <br />
              Telefon: 0176 55677271
              <br />
              E-Mail: info@abschleppdienst-schiek.de
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">2. Hosting und Server-Log-Dateien</h2>
            <p className="mb-4">
              Diese Website wird über Vercel gehostet. Beim Aufruf der Website werden technisch
              erforderliche Verbindungsdaten verarbeitet, insbesondere IP-Adresse, Datum und Uhrzeit
              des Zugriffs, aufgerufte Seite, Referrer, Browsertyp und Betriebssystem.
            </p>
            <p className="mb-4">
              Die Verarbeitung erfolgt zur technischen Bereitstellung, Stabilität und Sicherheit der
              Website auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Empfänger ist der
              Hosting-Dienstleister Vercel. Eine Verarbeitung in Drittländern, insbesondere in den
              USA, kann nicht ausgeschlossen werden.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">3. Kontaktaufnahme per Formular, E-Mail oder Telefon</h2>
            <p className="mb-4">
              Wenn Sie uns per Kontaktformular, E-Mail, WhatsApp oder Telefon kontaktieren,
              verarbeiten wir die von Ihnen mitgeteilten Daten zur Bearbeitung Ihrer Anfrage. Dazu
              gehören insbesondere Name, Telefonnummer, E-Mail-Adresse, Anliegen, gewünschter Termin
              und der Inhalt Ihrer Nachricht.
            </p>
            <p className="mb-4">
              Die Verarbeitung erfolgt zur Durchführung vorvertraglicher Maßnahmen oder zur
              Bearbeitung Ihrer Anfrage auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Soweit Sie uns
              freiwillig zusätzliche Angaben machen, erfolgt die Verarbeitung ergänzend auf Grundlage
              von Art. 6 Abs. 1 lit. f DSGVO.
            </p>
            <p className="mb-4">
              Für den Versand und Empfang von E-Mails sowie für die Domainverwaltung nutzen wir
              Leistungen der IONOS SE, Elgendorfer Straße 57, 56410 Montabaur. Empfänger der Daten
              sind daher wir selbst sowie IONOS als technischer E-Mail- und Domain-Dienstleister.
              Je nach konkreter technischer Ausgestaltung können hierbei auch Verbindungs- und
              Kommunikationsdaten verarbeitet werden.
            </p>
            <p className="mb-4">
              Wir speichern Anfragen nur so lange, wie dies zur Bearbeitung, Nachverfolgung und zur
              Erfüllung gesetzlicher Aufbewahrungspflichten erforderlich ist.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">4. Cookies, Local Storage und Einwilligungsverwaltung</h2>
            <p className="mb-4">
              Auf dieser Website wird Ihre Entscheidung zu optionalem Marketing-Tracking lokal im
              Browser gespeichert. Dafür verwenden wir technisch erforderliche Browser-Speicherungen
              wie Local Storage, um Ihre Einwilligung oder Ablehnung zu dokumentieren und bei
              weiteren Seitenaufrufen zu berücksichtigen.
            </p>
            <p className="mb-4">
              Die Speicherung dieser Entscheidung erfolgt auf Grundlage von § 25 Abs. 2 TDDDG sowie
              Art. 6 Abs. 1 lit. f DSGVO, da sie erforderlich ist, um Ihre Auswahl rechtssicher zu
              beachten.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">5. Google Ads Conversion-Tracking</h2>
            <p className="mb-4">
              Wir nutzen optional Google Ads Conversion-Tracking. Anbieter ist Google Ireland
              Limited, Gordon House, Barrow Street, Dublin 4, Irland.
            </p>
            <p className="mb-4">
              Das Google-Tag wird erst geladen, wenn Sie dem optionalen Marketing-Tracking
              ausdrücklich zustimmen. Ohne Einwilligung findet kein entsprechendes Marketing- oder
              Conversion-Tracking statt.
            </p>
            <p className="mb-4">
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG.
              Im Rahmen der Nutzung kann es zu einer Übermittlung personenbezogener Daten an Google
              LLC in den USA kommen. Google ist nach dem EU-US Data Privacy Framework zertifiziert.
            </p>
            <p className="mb-4">
              Ihre Einwilligung können Sie jederzeit über die Cookie-Einstellungen mit Wirkung für
              die Zukunft widerrufen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">6. Ihre Rechte</h2>
            <p className="mb-4">
              Ihnen stehen die gesetzlichen Rechte auf Auskunft, Berichtigung, Löschung,
              Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen
              Verarbeitungen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zu.
            </p>
            <p className="mb-4">
              Soweit die Verarbeitung auf Ihrer Einwilligung beruht, können Sie diese jederzeit mit
              Wirkung für die Zukunft widerrufen.
            </p>
            <p className="mb-4">
              Zudem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
              Zuständig ist insbesondere die Berliner Beauftragte für Datenschutz und
              Informationsfreiheit.
            </p>

            <div className="mt-12 pt-8 border-t-2" style={{ borderColor: '#020617' }}>
              <p className="text-sm opacity-70">Stand: April 2026</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
